import { useState } from 'react';
import { useModalViewport, modalShellStyle, ModalHeader } from '../modal-utils.jsx';
import { Portal } from '../components/boothly/portal.jsx';
import { Z } from '../lib/z-index.js';
import { useToast } from '../components/boothly/toast-provider.jsx';
import { supabase } from '../supabase.js';
import { F, T } from '../theme.jsx';

export function PasswordChangeSheet({ dark, onClose }) {
  const toast = useToast();
  const t = T[dark ? 'dark' : 'light'];
  const [pw1, setPw1] = useState('');
  const [pw2, setPw2] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { height: vh, kbOpen, offsetTop } = useModalViewport();

  const ready = pw1.length >= 8 && pw1 === pw2;

  const submit = async () => {
    if (!ready || submitting || !supabase) return;
    setSubmitting(true);
    try {
      const { error } = await supabase.auth.updateUser({ password: pw1 });
      if (error) {
        toast.error(error.message || 'Passwort konnte nicht geändert werden');
      } else {
        toast.success('Passwort geändert');
        onClose();
      }
    } catch (e) {
      toast.error(e.message || 'Fehler');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Portal>
      <div onClick={onClose} style={{
        position: 'fixed', inset: 0, zIndex: Z.nestedBackdrop,
        background: dark ? 'rgba(0,0,0,0.55)' : 'rgba(0,0,0,0.34)',
        backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)',
      }}/>
      <div onClick={e => e.stopPropagation()} style={modalShellStyle({ vh, kbOpen, offsetTop, F, dark, width: 380, radius: 24, padding: '20px 22px 22px', zIndex: Z.nestedSheet })}>
        <ModalHeader t={t} dark={dark} F={F} title="Passwort ändern" onClose={onClose} marginBottom={14} />
        <div style={{ background: dark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)', borderRadius: 12, padding: '0 14px', marginBottom: 8, border: `1px solid ${t.glassBorder}` }}>
          <input type="password" autoFocus value={pw1} onChange={e => setPw1(e.target.value)} placeholder="Neues Passwort (min. 8 Zeichen)"
            style={{ width: '100%', background: 'transparent', border: 'none', outline: 'none', padding: '12px 0', fontSize: 14, color: t.text, fontFamily: F, minWidth: 0 }}/>
        </div>
        <div style={{ background: dark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)', borderRadius: 12, padding: '0 14px', marginBottom: 14, border: `1px solid ${t.glassBorder}` }}>
          <input type="password" value={pw2} onChange={e => setPw2(e.target.value)} placeholder="Wiederholen"
            style={{ width: '100%', background: 'transparent', border: 'none', outline: 'none', padding: '12px 0', fontSize: 14, color: t.text, fontFamily: F, minWidth: 0 }}/>
        </div>
        {pw2 && pw1 !== pw2 && (
          <div style={{ fontSize: 12, color: t.accent.red.solid, marginBottom: 10, paddingLeft: 4 }}>Passwörter stimmen nicht überein.</div>
        )}
        <button onClick={submit} disabled={!ready || submitting} style={{
          width: '100%', padding: '13px',
          background: ready ? t.accent.blue.solid : (dark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)'),
          color: ready ? '#fff' : t.textMuted,
          border: 'none', borderRadius: 12,
          fontFamily: F, fontWeight: 700, fontSize: 14,
          cursor: ready && !submitting ? 'pointer' : 'not-allowed',
        }}>{submitting ? 'Speichere…' : 'Speichern'}</button>
      </div>
    </Portal>
  );
}
